import React from "react";
import { useUser } from "../../utils/UserContext";
import HostSideBar from "./HostSideBar";
import MerchantSideBar from "./MerchantSideBar";

export default () => {
  const { authenticationType } = useUser();
  return authenticationType === "HOST" ? <HostSideBar /> : <MerchantSideBar />;
};
